import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button,
  CircularProgress, Alert, Table, TableHead, TableBody, TableRow, TableCell,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const PatientSearch = () => {
  const [q, setQ] = React.useState("");
  const [results, setResults] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const search = async () => {
    if (!q.trim()) return;
    setLoading(true);
    try {
      const { json } = await httpClient(
        `${API_BASE_URL}/patients/search?q=${encodeURIComponent(q)}`
      );
      setResults(Array.isArray(json) ? json : json?.data || []);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <SearchIcon /> Recherche patient
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Recherche fulltext via /api/v1/patients/search.
      </Alert>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField fullWidth size="small" label="Nom / email"
              value={q} onChange={(e) => setQ(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && search()} />
            <Button variant="contained" onClick={search} disabled={loading || !q.trim()}>
              {loading ? <CircularProgress size={18} /> : "Chercher"}
            </Button>
          </Box>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Résultats <Chip label={results.length} size="small" />
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Prénom</TableCell>
                <TableCell>Nom</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Ville</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.length === 0 ? (
                <TableRow><TableCell colSpan={5} align="center">Aucun résultat</TableCell></TableRow>
              ) : results.map((p, i) => (
                <TableRow key={p.id || i}>
                  <TableCell>{p.id}</TableCell>
                  <TableCell>{p.firstName}</TableCell>
                  <TableCell>{p.lastName}</TableCell>
                  <TableCell>{p.email}</TableCell>
                  <TableCell>{p.city || p.address?.city}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: PatientSearch };
